import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import logo from "svg/logo.svg";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";

const Header = () => {
  const { firstname, lastname, hasPbAccess, storeCcn } = useSelector((state) => state.loggedInUser);
  const [show, setShow] = useState(false);

  return (
    // temporarily override bootstrap's default zIndex to prevent custom modals from being hidden by nav
    // can remove override after custom modals are replaced with bootstrap modals
    <Navbar expand="lg" className="bg-light shadow-sm py-0" sticky="top" style={{ zIndex: 9 }}>
      <Container fluid="xl">
        <Navbar.Brand className="fs-6 p-0 d-flex align-items-center">
          <img src={logo} alt="Logo" width={50} height={50} />
          Floorcovering Hub
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="offcanvasNavbar-expand-lg" onClick={() => setShow(true)} />
        <Navbar.Offcanvas
          show={show}
          onHide={() => setShow(false)}
          id="offcanvasNavbar-expand-lg"
          aria-labelledby="offcanvasNavbar-expand-lg"
          className="w-auto ps-5"
          placement="end"
        >
          <Offcanvas.Body className="navbar justify-content-end align-items-start">
            <Nav>
              {[
                ["/siteRepo", "Site Repository"],
                ["/laborTable", "Labor Table"],
                [`/priceQuote?storeNumber=${storeCcn ?? ""}`, "Price Quote"],
                ...(hasPbAccess ? [["/programBuilder", "Program Builder"]] : []),
              ].map(([link, text]) => (
                <NavLink
                  key={link}
                  title={text}
                  to={link}
                  className="nav-link text-end py-3"
                  onClick={() => setShow(false)}
                  style={({ isActive }) => ({
                    textUnderlineOffset: "1.25rem",
                    ...(isActive ? { textDecoration: "#0076c2 underline solid 0.25rem", color: "#0076c2" } : {}),
                  })}
                >
                  <div>{text}</div>
                </NavLink>
              ))}
              <Nav.Item className="d-flex justify-content-end">
                <div
                  className="ms-5 my-2 rounded-circle bg-white border d-flex justify-content-center align-items-center p-2"
                  style={{ width: 42, height: 42 }}
                >
                  <span>
                    {(firstname?.[0] ?? "").toUpperCase()}
                    {(lastname?.[0] ?? "").toUpperCase()}
                  </span>
                </div>
              </Nav.Item>
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
};

export default Header;
